/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppointmentPatientDto
 */
export interface AppointmentPatientDto {
    /**
     * Patient ID
     * @type {string}
     * @memberof AppointmentPatientDto
     */
    id: string;
    /**
     * Patient first name
     * @type {string}
     * @memberof AppointmentPatientDto
     */
    firstName: string;
    /**
     * Patient last name
     * @type {string}
     * @memberof AppointmentPatientDto
     */
    lastName: string;
    /**
     * Patient email
     * @type {string}
     * @memberof AppointmentPatientDto
     */
    email: string;
}

/**
 * Check if a given object implements the AppointmentPatientDto interface.
 */
export function instanceOfAppointmentPatientDto(value: object): value is AppointmentPatientDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function AppointmentPatientDtoFromJSON(json: any): AppointmentPatientDto {
    return AppointmentPatientDtoFromJSONTyped(json, false);
}

export function AppointmentPatientDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentPatientDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
    };
}

export function AppointmentPatientDtoToJSON(json: any): AppointmentPatientDto {
    return AppointmentPatientDtoToJSONTyped(json, false);
}

export function AppointmentPatientDtoToJSONTyped(value?: AppointmentPatientDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
    };
}

